import { ISearchPageBreadcrumbs } from 'api/types/searchPageApiTypes';
import { BreadCrumb } from 'components/Toolkit/BreadCrumbs/BreadCrumbs';

type TFormattedBreadcrumb =
  | {
      displayName: string;
      isNotLink: boolean;
      path?: undefined;
    }
  | {
      displayName: string;
      path: string;
    };

const filterBreadcrumbs = (
  breadcrumbs: ISearchPageBreadcrumbs[],
  filterTerm: string,
) => {
  return breadcrumbs.filter(
    (item, index) =>
      item.displayName !== filterTerm || index === breadcrumbs.length - 1,
  );
};

const removeLinkFromLastBreadcrumb = (
  breadcrumbs: TFormattedBreadcrumb[] | BreadCrumb[],
) => [
  ...breadcrumbs.slice(0, -1),
  {
    ...breadcrumbs[breadcrumbs.length - 1],
    isNotLink: true,
  },
];

export { filterBreadcrumbs, removeLinkFromLastBreadcrumb };
